export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";